import {useEffect, useState} from "react";
import axiosInstance from "../API/Axios/AxiosConfig";
import URLS from "../API/Axios/URLS";


export default function useCommunityStats() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    function fetchCommunityStats() {
        setLoading(true);
        axiosInstance.get(URLS.getCommunityStats).then((res) => {
            setData(res.data?.data);
        }).catch((err) => {
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        fetchCommunityStats();
    }, []);

    return [data, loading, fetchCommunityStats];

}